<template>
    <div id="app">

        <router-view></router-view>

    </div>
</template>

<script>
    export default {
        name: 'app',
    }
</script>

<style>
    @import "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,700&display=swap";
    @import "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css";
</style>
